"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PaymentProviderBox = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _checkoutUtils = require("@ori/checkout-utils");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _useCardDetailsConsent = require("../../hooks/useCardDetailsConsent");
var _models = require("../../models");
var _utils = require("../../utils");
var _FormattedMessage = require("../FormattedMessage");
var _CardDetailsConsentBox = require("./CardDetailsConsentBox");
var _PaymentMethodIcon = require("./PaymentMethodIcon");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/jsx-no-bind -- x */ const Root = (0, _mui.styled)('div')((param)=>{
    let { theme, ownerState: { isActive } } = param;
    return {
        position: 'relative',
        display: 'block',
        borderRadius: theme.shape.largeComponentRadius,
        cursor: 'pointer',
        border: "1px solid ".concat(theme.palette.grey[200]),
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.default.main,
        boxShadow: 'none',
        marginBottom: theme.spacing(3),
        transition: 'box-shadow 300ms, border-color 300ms',
        ...isActive && {
            border: "1px solid ".concat(theme.palette.background.paper),
            boxShadow: theme.shadows[3]
        },
        ...!isActive && {
            [theme.breakpoints.up('sm')]: {
                '&:hover': {
                    border: "1px solid ".concat(theme.palette.background.paper),
                    boxShadow: theme.shadows[3]
                }
            }
        }
    };
});
const Indicator = (0, _mui.styled)('div')((param)=>{
    let { theme, ownerState: { isActive } } = param;
    return {
        position: 'absolute',
        top: -1,
        left: -1,
        width: 50,
        height: 50,
        overflow: 'hidden',
        opacity: 0,
        borderTopLeftRadius: theme.shape.largeComponentRadius,
        transition: theme.transitions.create('opacity'),
        '&::before': {
            position: 'absolute',
            top: 0,
            left: 0,
            content: '""',
            transform: 'translate(-50%, -50%) rotate(45deg)',
            width: 50,
            height: 50,
            zIndex: 0,
            background: theme.palette.primary.main
        },
        ...isActive && {
            opacity: 1
        }
    };
});
const CheckHeavyIcon = (0, _mui.styled)(_icons.CheckHeavy)((param)=>{
    let { theme } = param;
    return {
        position: 'relative',
        left: 1,
        top: 1,
        fontSize: '2rem',
        color: theme.palette.text.primary
    };
});
const PaymentLabel = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        padding: theme.spacing(4, 3),
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(4)
        }
    };
});
const PaymentHeader = (0, _mui.styled)('div')({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    display: 'flex',
    flexWrap: 'wrap'
});
const FooterTextCardNumber = (0, _mui.styled)(_mui.Typography)({
    bottom: 15,
    left: 15
});
const FooterTextExpiration = (0, _mui.styled)(_mui.Typography)({
    position: 'absolute',
    bottom: 13,
    right: 15
});
const PaymentFooter = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: theme.palette.grey[100],
        borderTopColor: theme.palette.grey[200],
        borderTopStyle: 'solid',
        borderTopWidth: '1px',
        margin: theme.spacing(2, -4, -4),
        height: 55,
        borderBottomRightRadius: 10,
        borderBottomLeftRadius: 10,
        [theme.breakpoints.down('sm')]: {
            margin: theme.spacing(2, -3, -4)
        }
    };
});
const CardTextWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        height: 55,
        margin: theme.spacing(4, 0, 0, 2)
    };
});
const ProviderFormControl = (0, _mui.styled)(_mui.FormControl)((param)=>{
    let { theme } = param;
    return {
        margin: theme.spacing(2, 0, 0, 3)
    };
});
const ProviderFormControlLabel = (0, _mui.styled)(_mui.FormControlLabel)((param)=>{
    let { theme, ownerState: { checked } } = param;
    return {
        color: theme.palette.default.dark,
        ...checked && {
            color: theme.palette.primary.dark
        }
    };
});
const LazyImageTopIcon = (0, _mui.styled)(_components.LazyImage)({
    display: 'inline-block',
    height: 25,
    objectFit: 'contain',
    marginLeft: 'auto',
    lineHeight: '1',
    ["& .".concat(_components.lazyImageClasses.image)]: {
        width: 'auto'
    }
});
const ProviderName = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme, ownerState: { isActive } } = param;
    return {
        padding: theme.spacing(1, 0),
        marginRight: theme.spacing(3),
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        fontWeight: 'normal',
        ...isActive && {
            fontWeight: 'bold'
        }
    };
});
const ProviderDescription = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        marginTop: theme.spacing(2),
        marginRight: theme.spacing(6),
        color: theme.palette.grey[600]
    };
});
const PaymentProviderBox = (param)=>{
    let { paymentProviderGroup, activeProviderId, isCardDetailsConsent, onPaymentActivation } = param;
    const [activeProvider, setActiveProvider] = (0, _react.useState)(String(activeProviderId));
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const paymentProvider = paymentProviderGroup.paymentProviders[0];
    const isActive = paymentProviderGroup.paymentProviders.some((x)=>x.id === activeProviderId);
    const providerNameComponent = (0, _react.useRef)(null);
    const [isOpenTooltip, setIsOpenTooltip] = (0, _react.useState)(false);
    const handleProviderNameClick = ()=>{
        setIsOpenTooltip((prevState)=>!prevState);
    };
    const activatePaymentProvider = ()=>{
        if (onPaymentActivation && !isActive) {
            onPaymentActivation(paymentProvider.id);
        }
    };
    const activateRadioPaymentProvider = (event, value)=>{
        if (onPaymentActivation) {
            setActiveProvider(event.target.value);
            onPaymentActivation(Number(value));
        }
    };
    const { isRecurring, image, cardDetails, paymentMethodType, id } = paymentProvider;
    const { isUserConsent, toggleUserConsent } = (0, _useCardDetailsConsent.useCardDetailsConsent)(isCardDetailsConsent);
    const ownerState = {
        isActive
    };
    if (!paymentProviderGroup.paymentProviders.some((param)=>{
        let { id: providerId, isVisibleForNewOrder, visibility } = param;
        return (0, _utils.isProviderVisible)(providerId, visibility, isVisibleForNewOrder);
    })) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, {
        ownerState: ownerState,
        "data-payment-provider-id": id,
        "aria-checked": isActive,
        role: "checkbox",
        ...getTestIdProps(_models.TestId.PaymentProviderBox),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Indicator, {
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CheckHeavyIcon, {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PaymentLabel, {
                onClick: activatePaymentProvider,
                ...getTestIdProps(_models.TestId.PaymentLabel),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaymentHeader, {
                        ...getTestIdProps(_models.TestId.PaymentProviderHeader),
                        children: paymentProviderGroup.paymentProviders.filter((param)=>{
                            let { id: providerId, isVisibleForNewOrder, visibility } = param;
                            return (0, _utils.isProviderVisible)(providerId, visibility, isVisibleForNewOrder);
                        }).length === 1 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Tooltip, {
                                    open: isOpenTooltip ? (0, _checkoutUtils.isEllipsisActive)(providerNameComponent.current) : false,
                                    placement: "top-start",
                                    title: paymentProvider.name,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProviderName, {
                                        ref: providerNameComponent,
                                        ownerState: ownerState,
                                        onClick: handleProviderNameClick,
                                        onMouseEnter: ()=>setIsOpenTooltip(true),
                                        onMouseLeave: ()=>setIsOpenTooltip(false),
                                        children: paymentProvider.name
                                    })
                                }),
                                image ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(LazyImageTopIcon, {
                                    ...getTestIdProps(_models.TestId.PaymentProviderImage),
                                    loading: "eager",
                                    alt: image.alt,
                                    src: image.src
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PaymentMethodIcon.PaymentMethodIcon, {
                                    paymentMethodType: paymentMethodType
                                })
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProviderName, {
                            ownerState: ownerState,
                            children: paymentProviderGroup.name
                        })
                    }),
                    isActive && paymentProviderGroup.description ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProviderDescription, {
                        dangerouslySetInnerHTML: {
                            __html: paymentProviderGroup.description
                        }
                    }) : null,
                    isActive && paymentProviderGroup.paymentProviders.length > 1 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProviderFormControl, {
                        ...getTestIdProps(_models.TestId.PaymentProvidersRadioSelection),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.RadioGroup, {
                            "aria-labelledby": "demo-radio-buttons-group-label",
                            name: "radio-payment-providers",
                            value: activeProvider,
                            onChange: activateRadioPaymentProvider,
                            children: paymentProviderGroup.paymentProviders.filter((param)=>{
                                let { id: providerId, isVisibleForNewOrder, visibility } = param;
                                return (0, _utils.isProviderVisible)(providerId, visibility, isVisibleForNewOrder);
                            }).map((provider)=>{
                                const checked = Boolean(provider.id === activeProviderId);
                                const providerFormState = {
                                    checked
                                };
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProviderFormControlLabel, {
                                    ownerState: providerFormState,
                                    value: provider.id,
                                    control: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Radio, {}),
                                    label: provider.name,
                                    checked: checked
                                }, provider.id);
                            })
                        })
                    }) : null,
                    isActive && isRecurring && !cardDetails ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_CardDetailsConsentBox.CardDetailsConsentBox, {
                        isChecked: isUserConsent,
                        onChangeHandler: toggleUserConsent
                    }) : null,
                    isActive && isRecurring && cardDetails ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaymentFooter, {
                        ...getTestIdProps(_models.TestId.PaymentProviderFooter),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(CardTextWrapper, {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(FooterTextCardNumber, {
                                    ...getTestIdProps(_models.TestId.CardDetailsNumber),
                                    "data-di-mask": true,
                                    variant: "body1",
                                    children: [
                                        "\u2022\u2022\u2022\u2022 ",
                                        cardDetails.cardNumberLast4
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(FooterTextExpiration, {
                                    ...getTestIdProps(_models.TestId.CardDetailsExpiration),
                                    "data-di-mask": true,
                                    variant: "body1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                                            id: "expirationDate"
                                        }),
                                        ": ",
                                        cardDetails.expiryMonth,
                                        "/",
                                        cardDetails.expiryYear
                                    ]
                                })
                            ]
                        })
                    }) : null
                ]
            })
        ]
    });
};
exports.PaymentProviderBox = PaymentProviderBox;
